{
  "header": {
    "nameVariable": {
      "id": "280498f7-2264-427a-9102-319a73e07d7b",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6015",
      "displayName": "ProductInstanceUri",
      "variablePath": "<GroupIdentifier>.Identification.ProductInstanceUri",
      "dataType": "String",
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "modelVariable": {
      "id": "90caf97d-ca21-45e5-bc44-30d9901d6cbe",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6008",
      "displayName": "Model",
      "variablePath": "<GroupIdentifier>.Identification.Model",
      "dataType": "LocalizedText",
      "modellingRule": "Optional",
      "hasProperties": false
    },
    "file": ""
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "Robot.jpg"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Motion Device",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "valueVariable": {
                "id": "b83e9203-306a-47e5-9980-c49695ffe5a4",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6002",
                "displayName": "Manufacturer",
                "variablePath": "<GroupIdentifier>.Identification.Manufacturer",
                "dataType": "LocalizedText",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "valueVariable": {
                "id": "90caf97d-ca21-45e5-bc44-30d9901d6cbe",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6008",
                "displayName": "Model",
                "variablePath": "<GroupIdentifier>.Identification.Model",
                "dataType": "LocalizedText",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "valueVariable": {
                "id": "0c73cee8-1f52-491b-beaa-1ac55f1ea4ff",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6003",
                "displayName": "SerialNumber",
                "variablePath": "<GroupIdentifier>.Identification.SerialNumber",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Device Class",
              "valueVariable": {
                "id": "0a587f89-0bfc-459f-8bb5-b3de1b1d95f0",
                "modelUri": "http://opcfoundation.org/UA/DI/",
                "nodeId": "ns=1;i=15094",
                "displayName": "DeviceClass",
                "variablePath": "DeviceClass",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Flange Load Mass",
              "valueVariable": {
                "id": "7d74ecc2-8ae7-47d4-aec6-500d54081910",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=6624",
                "displayName": "Mass",
                "variablePath": "FlangeLoad.Mass",
                "dataType": "Double",
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": true,
      "title": "New Section",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Motion Profile",
              "valueVariable": {
                "id": "1d825b4c-c0dd-48d8-8f20-f0c466974661",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15808",
                "displayName": "MotionProfile",
                "variablePath": "MotionProfile",
                "dataType": "Enum",
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "OTHER",
                  "1": "ROTARY",
                  "2": "ROTARY_ENDLESS",
                  "3": "LINEAR",
                  "4": "LINEAR_ENDLESS"
                }
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Actual Position",
              "valueVariable": {
                "id": "752300e9-492d-4e63-88e6-11e360e6a9c7",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15863",
                "displayName": "ActualPosition",
                "variablePath": "ParameterSet.ActualPosition",
                "dataType": "Double",
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Actual Speed",
              "valueVariable": {
                "id": "75564757-2a72-4cbc-bb5e-6e6d07a0d3b1",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=16668",
                "displayName": "ActualSpeed",
                "variablePath": "ParameterSet.ActualSpeed",
                "dataType": "Double",
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              }
            }
          ]
        }
      ],
      "placeholderObject": "Axes.<AxisIdentifier>.[PLACEHOLDER]",
      "titleVariable": {
        "id": "75b768c4-3ae1-42a3-8d04-0353f8f18677",
        "modelUri": "https://opcfoundation.org/UA/",
        "nodeId": "i=61",
        "displayName": "baseName",
        "variablePath": "baseName",
        "dataType": "String",
        "modellingRule": "Mandatory",
        "hasProperties": false
      }
    }
  ]
}
